import { useMemo, useState } from "react";
import { Check, ChevronDown, Copy, FileText, Search } from "lucide-react";
import { api } from "@/lib/api";

const requirementTemplates = [
  {
    id: 1,
    title: "PENGECEKAN SERTIFIKAT",
    items: [
      "Blanko pengecekan",
      "Sertifikat asli",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "FC KTP+KK penerima kuasa",
      "Hasil Pengecekan, SPS, dan Tanda Terima cetak berwarna 3x",
      "Surat Pengantar dari Pejabat Pembuat Akta Tanah ( PPAT )",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 2,
    title: "ROYA",
    items: [
      "Blanko roya",
      "Sertifikat asli",
      "Sertifikat hak tanggungan asli",
      "Surat roya asli bermaterai 10.000",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa",
    ],
  },
  {
    id: 3,
    title: "PENINGKATAN HAK MILIK",
    items: [
      "Blanko peningkatan",
      "Sertifikat asli",
      "Fotokopi sertifikat rangkap 2",
      "Fotokopi KTP + KK pemilik 2X",
      "Fotokopi legalisir PBB 2023",
      "Fotokopi legalisir IMB",
      "Materai 10.000 ( 2 )",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL)",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Semisal tidak ada IMB di ganti surat keterangan lurah",
      "Foto Gambar Rumah / Bangunan tampak depan cetak berwarna",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 4,
    title: "PENGGABUNGAN",
    items: [
      "Blanko penggabungan",
      "Sertifikat asli + fotokopi",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Hasil Gambar Geotagging dicetak berwarna (Aplikasi GPS Map Camera)",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 5,
    title: "BALIK NAMA ( JUAL BELI )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Akta jual beli asli + fotokopi",
      "Fotokopi KTP + KK penjual & pembeli 2x",
      "Fotokopi Legalisir Buku Nikah / Akta Nikah Penjual",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli (Kantor Pajak Pratama )",
      "Fotokopi NPWP pembeli (jika ada)",
      "Materai 10.000 ( 2 )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 6,
    title: "BALIK NAMA ( HIBAH )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Akta hibah asli + fotokopi",
      "Fotokopi KTP + KK pemberi & penerima hibah 2x",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP / SKB hibah asli (Kantor Pajak Pratama )",
      "Materai 10.000 ( 2 )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 7,
    title: "BALIK NAMA ( WARIS-APHW )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Surat keterangan waris asli / Fotokopi surat keterangan waris legalisir nasegel pos",
      "Akte Pembagian Hak Waris (APHW)",
      "Fotokopi legalisir akte kematian 2x",
      "Fotokopi KTP + KK semua ahli waris 2x",
      "Fotokopi legalisir PBB 2023",
      "Materai 10.000 (2)",
      "BPHTB asli (Dispenda)",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 8,
    title: "BALIK NAMA ( WARIS )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Surat keterangan waris asli / Fotokopi surat keterangan waris legalisir nasegel pos",
      "Surat kuasa ahli waris asli ( jika ahli waris lebih dari 1 )",
      "Fotokopi legalisir surat kematian 2x",
      "Fotokopi KTP + KK semua ahli waris 2x",
      "Fotokopi legalisir PBB 2023",
      "Materai 10.000 (2)",
      "BPHTB asli (Dispenda)",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 9,
    title: "BALIK NAMA ( APHB )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Akta pembagian hak bersama ( APHB ) asli + fotokopi",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli (Kantor Pajak Pratama )",
      "Materai 10.000 ( 2 )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 10,
    title: "BALIK NAMA ( WAKAF )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Ikrar wakaf asli + fotokopi",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK pemberi & penerima hak baru / nadzir 2x",
      "Fotokopi legalisir PBB 2023",
      "Surat keputusan nadzir",
      "Pengesahan nadzir",
      "Materai 10.000 ( 2 )",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 11,
    title: "BALIK NAMA ( LELANG )",
    items: [
      "Blanko balik nama",
      "Sertifikat asli yang sudah di plotting",
      "Risalah lelang asli",
      "Bukti Kwitansi Pelunasan asli",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (yang sudah tervalidasi)",
      "SSP asli (yang sudah tervalidasi)",
      "Materai 10.000 ( 2 )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 12,
    title: "PEMECAHAN SERTIFIKAT",
    items: [
      "Blanko pemecahan",
      "Sertifikat asli + fotokopi",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Hasil Gambar Geotagging dicetak berwarna (Aplikasi GPS Map Camera)",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 13,
    title: "GANTI BLANKO LAMA / RUSAK",
    items: [
      "Blanko untuk ganti blanko sertipfikat",
      "Sertifikat asli + fotokopi",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 14,
    title: "GANTI BLANKO ( SERTIFIKAT HILANG)",
    items: [
      "Blanko untuk ganti blanko sertifikat",
      "Fotokopi sertifikat ( jika ada )",
      "Surat kehilangan dari kepolisian asli",
      "Fotokopi SKPT",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 15,
    title: "SURAT KETERANGAN PENDAFTARAN TANAH ( SKPT )",
    items: [
      "Blanko SKPT",
      "Fotokopi sertifikat ( jika ada )",
      "Fotokopi KTP + KK pemilik",
      "Permohonan SKPT ( sudah ada di dalam blanko SKPT )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 16,
    title: "SURAT KETERANGAN PENDAFTARAN TANAH ( SKPT ) Pemilik Sudah Meninggal",
    items: [
      "Blanko SKPT",
      "Fotokopi sertifikat ( jika ada )",
      "Fotokopi legalisir surat keterangan waris",
      "Fotokopi legalisir akte kematian",
      "Fotokopi KTP + KK semua ahli waris",
      "Permohonan SKPT ( sudah ada di dalam blanko SKPT )",
      "Surat kuasa Asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 17,
    title: "SERTIFIKAT PENGGANTI KARENA HILANG ( Jika Pemilik Sudah Meninggal )",
    items: [
      "Blanko sertifikat hilang",
      "Fotokopi sertifikat ( jika ada )",
      "Surat kehilangan dari kepolisian asli",
      "Fotokopi SKPT ( jika ada )",
      "Fotokopi legalisir surat keterangan waris",
      "Fotokopi legalisir akte kematian",
      "Fotokopi KTP + KK semua ahli waris",
      "Fotokopi legalisir surat kuasa ahli waris",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 18,
    title: "PENGEMBALIAN BATAS",
    items: [
      "Blanko pengembalian batas",
      "Fotokopi sertifikat",
      "Fotokopi KTP + KK pemilik",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Hasil Gambar Geotagging dicetak berwarna (Aplikasi GPS Map Camera)",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 19,
    title: "PERMOHANAN HAK MILIK ( HGB BERAKHIR )",
    items: [
      "Blanko peta bidang + permohonan hak milik + pendaftaran SK",
      "Sertifikat asli",
      "Fotokopi sertifikat rangkap 2",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "Fotokopi legalisir IMB ( jika tidak ada diganti dengan SK Kelurahan)",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL )",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 20,
    title: "KONVERSI",
    items: [
      "Blanko peta bidang + konversi",
      "Risalah tanah asli (1 Bendel = 10 lembar)",
      "Bukti Perolehan asli",
      "Hasil Peta Bidang asli",
      "Fotokopi KTP + KK pemilik",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli (Kantor Pajak Pratama )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 21,
    title: "PEMBAHARUAN HGB ( HGB BERAKHIR )",
    items: [
      "Blanko peta bidang + pembaharuan HGB + pendaftaran SK",
      "Sertifikat asli",
      "Fotokopi legalisir sertifikat 2x",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "Fotokopi legalisir IMB ( jika ada )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 22,
    title: "PERPANJANGAN HGB ( HGB belum berakhir )",
    items: [
      "Blanko perpanjangan HGB + pendaftaran SK",
      "Sertifikat asli + fotokopi 2x",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023 2x",
      "Fotokopi legalisir IMB ( jika ada )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 23,
    title: "MERGER",
    items: [
      "Blanko merger",
      "Sertifikat asli",
      "Sertifikat hak tanggungan asli",
      "Fotokopi Surat Roya",
      "Fotokopi Akta merger legalisir dari Bank",
      "Fotokopi surat keterangan waris legalisir",
      "Fotokopi akte kematian legalisir",
      "Fotokopi KTP + KK ahli waris",
      "Surat Kuasa Asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris/ Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 24,
    title: "GANTI NAMA BANK",
    items: [
      "Blanko ganti nama bank",
      "Sertifikat asli",
      "Sertifikat hak tanggungan asli",
      "Fotokopi surat roya",
      "Lampiran perubahan nama dari bank",
      "Fotokopi KTP + KK pemilik",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 25,
    title: "PERMOHONAN ( HGB BERAKHIR ) Bila Pemilik Meninggal",
    items: [
      "Blanko penghapusan hak + peta bidang + permohonan hak milik + pendaftaran SK",
      "Sertifikat asli",
      "Fotokopi sertifikat 2x",
      "Surat keterangan waris asli",
      "Fotokopi legalisir surat keterangan waris 2x",
      "Fotokopi legalisir akte kematian 2x",
      "Fotokopi KTP + KK semua ahli waris 2x",
      "Fotokopi legalisir PBB 2023 2x",
      "BPHTB Asli (Dispenda)",
      "Fotokopi legalisir IMB",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL )",
      "Surat kuasa ahli waris asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 26,
    title: "PENINGKATAN HAK MILIK",
    items: [
      "Blanko Peningkatan",
      "Sertifikat asli",
      "Fotokopi sertifikat 2 rangkap",
      "Fotokopi KTP + KK Pemilik 2x",
      "Fotokopi legalisir PBB 2023 2x",
      "Fotokopi legalisir IMB",
      "Materai 10.000 ( 2 )",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa 2x",
      "Semisal tidak ada IMB buat surat keterangan dari Kelurahan",
      "Foto Bangunan/Rumah tampak depan cetak berwarna",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 27,
    title: "TANAH NEGARA BELUM BERSERTIFIKAT",
    items: [
      "Blanko Peta Bidang+ Permohonan hak milik (bawa ke kelurahan) + Pendaftaran SK",
      "Risalah tanah asli",
      "Bukti perolehan asli",
      "Fotokopi KTP + KK pemilik",
      "Fotokopi legalisir PBB 2023",
      "Surat kuasa asli bermateri 10.000",
      "Fotokopi KTP+KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 28,
    title: "WAKAF BELUM BERSERTIFIKAT",
    items: [
      "Blanko pengakuan (bawa ke kelurahan)",
      "Risalah tanah asli",
      "Fotokopi KTP + KK pemilik",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli",
      "Ikrar wakaf asli",
      "Fotokopi KTP + KK pemberi & penerima hak baru / nadzir",
      "Surat keputusan nadzir",
      "Pengesahan nadzir",
      "Surat Kuasa Asli / Surat Tugas Asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 29,
    title: "PERMOHONAN HGB (PENURUNAN HM KE HGB BADAN HUKUM)",
    items: [
      "Blanko Peta bidang + Permohonan HGB + Pendaftaran SK",
      "Akta pelepasan",
      "Fotokopi akta pelepasan legalisir",
      "Fotokopi sertifikat 3x",
      "Anggaran dasar (identitas yayasan : SIUP, IDP,dll)",
      "PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli",
      "Fotokopi KTP + KK pemilik yayasan 4x",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 4x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
      "Semua permohonan di bubuhi tanda tangan dengan stempel yayasan",
    ],
  },
  {
    id: 30,
    title: "Ganti Nama",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Surat Pernyataan Diketahui RT dan RW",
      "Fotokopi KTP + KK pemilik 2x",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 31,
    title: "Ganti Nama",
    items: [
      "Blanko balik nama",
      "Sertifikat asli",
      "Fotokopi legalisir Putusan Pengadilan ( legalisir pengadilan negeri)",
      "Fotokopi KTP + KK pemilik 2x",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 2x",
    ],
  },
  {
    id: 32,
    title: "Legalisir Sertifikat untuk keperluan HO/SIUP, Permohonan SHM/HGB, AP, KRK,IMB,PBG,KKPR",
    items: [
      "Isi formulir yang telah disediakan oleh CRS",
      "Sertifikat asli",
      "Fotokopi sertifikat 3 Rangkap (Maksimal)",
      "Fotokopi KTP + KK pemilik sertifikat",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
    ],
  },
  {
    id: 33,
    title: "Peta Bidang",
    items: [
      "Blangko Peta Bidang",
      "Risalah Tanah",
      "Fotokopi KTP + KK Pemilik",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
      "Fotokopi PBB 2023",
      "Hasil Gambar Geotagging dicetak berwarna (Aplikasi GPS Map Camera)",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 34,
    title: "Pembatalan Sertifikat ( Blangko Blokir )",
    items: [
      "Permohonan",
      "Fotokopi KTP & KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000 jika dikuasakan",
      "Sertifikat Hak Atas Tanah Asli",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Dokumen Penetapan / Putusan Pengadilan ( Legalisir Pengadilan )",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 35,
    title: "PERPANJANGAN HGB ( HGB berakhir )",
    items: [
      "Blanko peta bidang + pembaharuan HGB + pendaftaran SK",
      "Sertifikat asli",
      "Fotokopi legalisir sertipikat 2x",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "Fotokopi legalisir IMB ( jika ada )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "FC KTP+KK penerima Kuasa 2x",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 36,
    title: "Pendaftaran SK",
    items: [
      "Blanko Pendaftaran SK",
      "SK Asli (dari BPN)",
      "Fotokopi KTP & KK pemilik",
      "Fotokopi legalisir PBB 2023",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP+KK Penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 37,
    title: "IPPT/PERTEK",
    items: [
      "Blanko IPPT",
      "Fotokopi Sertifikat",
      "Fotokopi KTP + KK Pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 38,
    title: "Merger",
    items: [
      "Blanko Merger",
      "Sertifikat Asli",
      "Sertifikat Hak Tanggungan Asli",
      "Fotokopi Surat Roya",
      "Fotokopi Akta Penggabungan",
      "Pendaftaran Online oleh PPAT",
      "Fotokopi KTP + KK Pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 39,
    title: "HT",
    items: [
      "Blanko Pembebanan Hak / Merger",
      "Sertifikat Asli SHM/SHGB/HMSarusun",
      "Sura Kuasa dari PPAT",
      "Surat Pengantar dari PPAT",
      "Pendaftaran Online",
      "SKMHT ( tidak wajib )",
      "APHT",
      "KK + KTP Penerima & Pemberi Kuasa",
      "Identitas Pejabat Bank ( KTP Legalisir + SK Penunjukan )",
      "Akta Pendirian Bank",
      "Model A Pengecekan",
      "Fotokopi PK ( Tidak Wajib )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 40,
    title: "Cessie",
    items: [
      "Blanko Pembebanan Hak / Merger",
      "Sertifikat Asli SHM/SHGB/HMSarusun",
      "Sertipikat HT",
      "Fotokopi KTP + KK Pemilik",
      "Akta Cessie",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 41,
    title: "PERMOHANAN HAK MILIK",
    items: [
      "Blanko peta bidang + permohonan hak milik + pendaftaran SK",
      "Fotokopi KTP + KK pemilik 3x",
      "Fotokopi legalisir PBB 2023",
      "BPHTB asli (Dispenda)",
      "SSP asli",
      "Surat Kuasa Asli Bermaterai 10.000",
      "FC KTP+KK Penerima Kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 42,
    title: "Blokir",
    items: [
      "Blanko Blokir",
      "Permohonan (Surat Permohonan)",
      "Fotokopi KTP & KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000 Jika di Kuasakan",
      "Fotokopi Sertifikat (Jika Ada)",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Dokumen Penetapan / Putusan Pengadilan ( Legalisir Pengadilan ) (jika Ada)",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 43,
    title: "Permohonan Hak Milik (HGB Belum Berakhir)",
    items: [
      "Blanko Penghapusan Hak + Peta Bidang + Permohonan Hak Milik + Pendaftaran SK",
      "Sertifikat asli",
      "Fotokopi legalisir sertipikat rangkap 3 (legalisir BPN)",
      "Fotokopi KTP + KK pemilik 3x",
      "Akta Pelepasan Notariil",
      "Fotokopi legalisir PBB 2023",
      "Fotokopi legalisir IMB",
      "Jika tidak ada IMB diganti degan SK Kelurahan",
      "Rekomendasi permnas asli 2 lembar (jika ada HPL)",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa 3x",
      "Legalisir dapat dilakukan di Kecamatan/ Notaris/ Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 44,
    title: "Penghapusan Hak",
    items: [
      "Sertifikat Asli",
      "Akta Pelepasan Asli",
      "Fotokopi PPh",
      "Fotokopi KTP + KK pemilik",
      "Surat kuasa asli bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
    ],
  },
  {
    id: 45,
    title: "Tapak Kavling",
    items: [
      "Blanko Tapak Kavling",
      "Fotokopi Sertifikat",
      "Fotokopi KTP + KK Pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa",
      "Foto Lokasi cetak berwarna",
      "Dibelakang blanko digambar denah sederhana rencana pemecahan",
    ],
  },
  {
    id: 46,
    title: "PERMOHONAN HAK",
    items: [
      "Blanko Peningkatan",
      "Sertifikat asli",
      "Fotokopi sertifikat 2 rangkap",
      "Fotokopi KTP + KK Pemilik 2x",
      "Fotokopi legalisir PBB 2023 2x",
      "Materai 10.000 ( 2 )",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK Penerima Kuasa 2x",
      "Foto Bangunan/Rumah tampak depan cetak berwarna",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 47,
    title: "PENURUNAN HAK MILIK KE HAK GUNA BANGUNAN",
    items: [
      "Blanko Perubahan Hak",
      "Surat Permohonan",
      "Sertifikat asli",
      "Fotokopi sertifikat 2 rangkap",
      "Fotokopi KTP + KK pemilik 2x",
      "Fotokopi legalisir PBB 2023",
      "Materai 10.000 ( 2 )",
      "Rekomendasi perumnas asli 2 lembar ( jika ada HPL )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa 2x",
      "Foto Gambar Rumah / Bangunan cetak berwarna",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 48,
    title: "SURAT KETERANGAN TANAH ( SKT )",
    items: [
      "Blanko SKT",
      "Fotokopi sertifikat ( jika ada )",
      "Fotokopi KTP + KK pemilik",
      "Permohonan SKT ( sudah ada di dalam blanko SKT )",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 49,
    title: "SURAT KETERANGAN TANAH ( SKT ) Sertifikat Hilang Pemilik Sudah Meninggal",
    items: [
      "Blanko SKT",
      "Fotokopi sertifikat ( jika ada )",
      "Fotokopi legalisir surat keterangan waris",
      "Fotokopi legalisir surat kematian",
      "Fotokopi KTP + KK semua ahli waris",
      "Permohonan SKT ( sudah ada di dalam blanko SKT )",
      "Surat kuasa Asli bermaterai 10.000",
      "Fotokopi KTP+KK penerima kuasa",
      "Legalisir dapat dilakukan di Kecamatan, Notaris / Kantor Pelayanan Terpadu",
    ],
  },
  {
    id: 50,
    title: "PENGHAPUSAN BPHTB & PPH TERHUTANG",
    items: [
      "Blanko Model A",
      "Sertifikat Asli",
      "Bukti BPHTB Asli yang telah tervalidasi",
      "Bukti PPH Asli",
      "Fotokopi KTP+KK Pemilik",
      "Surat Kuasa Bermaterai 10.000",
      "Fotokopi KTP+KK Penerima Kuasa",
    ],
  },
  {
    id: 51,
    title: "Pencatatan IPPT/Pertek",
    items: [
      "Blanko roya",
      "Sertifikat asli",
      "Hasil IPPT/Pertek asli",
      "Hasil KKPR asli",
      "Fotokopi KTP + KK pemilik",
      "Surat Kuasa Asli Bermaterai 10.000",
      "Fotokopi KTP + KK penerima kuasa",
    ],
  },
];

const formatTemplateText = (template) =>
  `${template.title}\n${template.items.map((item, index) => `${index + 1}. ${item}`).join("\n")}`;

export default function Template() {
  const [query, setQuery] = useState("");
  const [copiedId, setCopiedId] = useState(null);
  const [expandedIds, setExpandedIds] = useState(() => new Set());

  const filteredTemplates = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return requirementTemplates;
    }

    return requirementTemplates.filter((template) => {
      const searchableText = `${template.title} ${template.items.join(" ")}`.toLowerCase();
      return searchableText.includes(normalizedQuery);
    });
  }, [query]);

  const handleCopy = async (template) => {
    await navigator.clipboard.writeText(formatTemplateText(template));
    api.post("/audit", { action: "template.copy", metadata: { template_id: template.id, title: template.title } }).catch(() => {});
    setCopiedId(template.id);
    window.setTimeout(() => setCopiedId(null), 1600);
  };

  const toggleTemplate = (templateId) => {
    setExpandedIds((currentIds) => {
      const nextIds = new Set(currentIds);

      if (nextIds.has(templateId)) {
        nextIds.delete(templateId);
      } else {
        nextIds.add(templateId);
      }

      return nextIds;
    });
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6 pt-20 lg:pt-8 relative z-10 fade-in">
      <div className="flex flex-col gap-5 mb-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gold/10 flex items-center justify-center text-gold">
            <FileText className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-2xl font-display font-semibold text-ink dark:text-white">Template Persyaratan</h1>
            <p className="text-sm text-ink-soft dark:text-white/60">Daftar syarat dari PERSYARATAN LENGKAP.pdf</p>
          </div>
        </div>

        <div className="relative w-full lg:w-96">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft dark:text-white/50" />
          <input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            className="w-full rounded-lg border border-ink/10 bg-white py-3 pl-10 pr-4 text-sm text-ink shadow-sm outline-none transition focus:border-gold focus:ring-2 focus:ring-gold/20 dark:border-white/10 dark:bg-ink-soft dark:text-white"
            placeholder="Cari template persyaratan..."
            type="search"
          />
        </div>
      </div>

      <div className="flex items-center justify-between rounded-lg border border-ink/5 bg-white px-4 py-3 text-sm text-ink-soft shadow-sm dark:border-white/5 dark:bg-ink-soft dark:text-white/60">
        <span>{filteredTemplates.length} template ditemukan</span>
        <span>Total {requirementTemplates.length} template</span>
      </div>

      {filteredTemplates.length > 0 ? (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
          {filteredTemplates.map((template) => {
            const isCopied = copiedId === template.id;
            const isExpanded = expandedIds.has(template.id);

            return (
              <div
                key={template.id}
                className="bg-white dark:bg-ink-soft border border-ink/5 dark:border-white/5 rounded-xl shadow-sm overflow-hidden flex flex-col"
              >
                <button
                  type="button"
                  onClick={() => toggleTemplate(template.id)}
                  aria-expanded={isExpanded}
                  className="w-full p-5 border-b border-ink/5 bg-gray-50 text-left transition hover:bg-gold/5 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gold/20 dark:border-white/5 dark:bg-black/20 dark:hover:bg-white/5"
                >
                  <div className="flex items-start gap-3">
                    <span className="shrink-0 w-8 h-8 rounded-lg bg-gold/10 text-gold text-sm font-semibold flex items-center justify-center">
                      {template.id}
                    </span>
                    <h2 className="min-w-0 flex-1 font-semibold text-ink dark:text-white leading-snug">{template.title}</h2>
                    <ChevronDown
                      className={`mt-1 h-4 w-4 shrink-0 text-ink-soft transition-transform dark:text-white/60 ${
                        isExpanded ? "rotate-180" : ""
                      }`}
                    />
                  </div>
                </button>

                {isExpanded && (
                  <div className="p-5 flex-1">
                    <ul className="space-y-3">
                      {template.items.map((item, idx) => (
                        <li key={idx} className="flex gap-3 text-sm text-ink-soft dark:text-white/70">
                          <span className="shrink-0 w-5 text-right font-medium text-gold">{idx + 1}.</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className={`p-5 ${isExpanded ? "pt-0" : ""}`}>
                  <button
                    type="button"
                    onClick={() => handleCopy(template)}
                    className="w-full inline-flex items-center justify-center gap-2 rounded-lg border border-ink/10 bg-white px-4 py-2.5 text-sm font-medium text-ink transition hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold/20 dark:border-white/10 dark:bg-black/20 dark:text-white"
                  >
                    {isCopied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                    {isCopied ? "Tersalin" : "Copy"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="rounded-xl border border-dashed border-ink/10 bg-white p-8 text-center text-sm text-ink-soft dark:border-white/10 dark:bg-ink-soft dark:text-white/60">
          Tidak ada template yang cocok dengan pencarian.
        </div>
      )}
    </div>
  );
}
